import React from 'react';
import ReactDOM from 'react-dom/client';

export class CollapseBtn extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isCollapsed: true
        };
    }

    handleClick(e) {
        const parent = e.target.parentElement.parentElement;
        const target = parent.getAttribute('data-target');
        if (target) {
            const targetElement = document.querySelector(target);
            if (targetElement !== null) {
                // toggle the class
                targetElement.classList.toggle('hidden');
            }
        }

        this.setState({
            isCollapsed: !this.state.isCollapsed
        });
    }

    render() {
        return <>
            <button onClick={(e) => this.handleClick(e)}
                    className={!this.state.isCollapsed ? ' transform rotate-45' : ''}>
                <img src="/images/icons/plus.svg"
                     className="lg:w-auto lg:h-auto w-6 h-6"
                     alt="plus"/>
            </button>
        </>;

    }
}

if (document.querySelectorAll('.collapse-btn').length) {
    const collapseBtns = document.querySelectorAll('.collapse-btn');
    collapseBtns.forEach(collapseBtn => {
        let btn = ReactDOM.createRoot(collapseBtn)
        btn.render(<CollapseBtn/>);
    });
}
